(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8534],{

/***/ 18534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ layouts_ProductPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/productSlice.js
var productSlice = __webpack_require__(73278);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/currencySlice.js
var currencySlice = __webpack_require__(74542);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/viewedSlice.js
var viewedSlice = __webpack_require__(89780);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/styles/index.js + 11 modules
var styles = __webpack_require__(92134);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./seo/JsonLd.js
var JsonLd = __webpack_require__(37286);
// EXTERNAL MODULE: ./containers/index.js + 33 modules
var containers = __webpack_require__(21341);
// EXTERNAL MODULE: ./lib/getProductWithoutQuantity.js
var getProductWithoutQuantity = __webpack_require__(3506);
// EXTERNAL MODULE: ./lib/config.js
var config = __webpack_require__(6668);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./hooks/use-local-storage.js
var use_local_storage = __webpack_require__(34670);
// EXTERNAL MODULE: ./utils/index.js + 3 modules
var utils = __webpack_require__(70214);
// EXTERNAL MODULE: ./seo/Mindbox.js
var Mindbox = __webpack_require__(22182);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var react_loading_skeleton_lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./node_modules/react-in-viewport/dist/es/index.js
var dist_es = __webpack_require__(19231);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./layouts/ProductPage/components/Collections.module.scss
var Collections_module = __webpack_require__(55574);
var Collections_module_default = /*#__PURE__*/__webpack_require__.n(Collections_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./layouts/ProductPage/components/Collections.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var perPage = 10;
var WideCollection = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7935).then(__webpack_require__.bind(__webpack_require__, 57935));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(57935)];
    }
  }
});
var RowSlider = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7266).then(__webpack_require__.bind(__webpack_require__, 87266));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87266)];
    }
  }
});

var NarrowCollection = function NarrowCollection(_ref) {
  var title = _ref.title,
      products = _ref.products,
      currency = _ref.currency;
  if (!products || products.length === 0) return null;
  (0,react.useEffect)(function () {
    if (products && products.length) {
      Ecommerce/* default.viewItemList */.ZP.viewItemList((0,getProductWithoutQuantity/* default */.Z)(products).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          external_id: item.model.slug
        });
      }), currency, title);
    }
  }, [products, title]);

  var handleClickCard = function handleClickCard(product, index) {
    var newProducts = (0,getProductWithoutQuantity/* default */.Z)([product]).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        external_id: item.model.slug
      });
    });
    Ecommerce/* default.viewItemList */.ZP.viewItemList(newProducts, currency, title, 'select_item', index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (Collections_module_default()).collectionItem,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styles/* Container */.W2, {
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
        component: "h2",
        className: (Collections_module_default()).collectionTitle,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RowSlider, {
        arrowsOutside: true,
        narrowCollection: true,
        children: products.map(function (product, idx) {
          var _product$model;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              handleClickCard(product, idx + 1);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductCard */.Il, _objectSpread(_objectSpread({}, product), {}, {
              mod: "narrowCollection",
              titleLimit: true,
              pageName: title,
              isSafari: true,
              indexCard: idx + 1
            }))
          }, (product === null || product === void 0 ? void 0 : (_product$model = product.model) === null || _product$model === void 0 ? void 0 : _product$model.id) || idx);
        })
      })]
    })
  });
};

var SkeletonContainer = function SkeletonContainer() {
  var skeletons = Array(4).fill(true);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles/* Container */.W2, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Collections_module_default()).skeletonTitle,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
        count: 1,
        height: "100%",
        width: "20%",
        style: {
          marginBottom: '24px',
          marginLeft: '12px'
        }
      }, 'skeleton-name')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Collections_module_default()).skeletonContainer,
      children: skeletons.map(function (_item, idx) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((Collections_module_default()).skeleton, idx === 2 && (Collections_module_default()).skeletonSizeOne, idx === 3 && (Collections_module_default()).skeletonSizeTwo),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            count: 1,
            height: "76%",
            width: "100%",
            style: {
              marginBottom: '24px'
            }
          }, "".concat(idx, "-skeleton-shop1")), /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            count: 1,
            height: "4%",
            width: "30%",
            style: {
              marginBottom: '8px'
            }
          }, "".concat(idx, "-skeleton-shop2")), /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            count: 1,
            height: "7%",
            width: "100%",
            style: {
              marginBottom: '8px'
            }
          }, "".concat(idx, "-skeleton-shop3")), /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            count: 1,
            height: "4%",
            width: "35%",
            style: {
              marginBottom: '8px'
            }
          }, "".concat(idx, "-skeleton-shop4"))]
        }, idx);
      })
    })]
  });
};

var Block = function Block(props) {
  var forwardedRef = props.forwardedRef;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ref: forwardedRef,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonContainer, {})
  });
};

var ViewportBlock = (0,dist_es/* default */.ZP)(Block);

var Collections = function Collections(_ref2) {
  var collectionIds = _ref2.collectionIds,
      lookId = _ref2.lookId,
      modelSlug = _ref2.modelSlug,
      currency = _ref2.currency;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(null),
      look = _useState[0],
      setLook = _useState[1];

  var _useState2 = (0,react.useState)({}),
      collections = _useState2[0],
      setCollections = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      loadedCollections = _useState3[0],
      setLoadedCollections = _useState3[1];

  var getLook = (0,react.useCallback)(function () {
    if (lookId) {
      dispatch((0,productSlice/* fetchProductLooks */.AK)({
        look_id: lookId,
        onSuccess: function onSuccess(data) {
          var _data$look;

          setLook((data === null || data === void 0 ? void 0 : (_data$look = data.look) === null || _data$look === void 0 ? void 0 : _data$look.data) || true);
        },
        onError: function onError() {
          setLook(true);
        }
      }));
    }
  }, [lookId, dispatch]);

  var getCollection = function getCollection(id) {
    if (!loadedCollections[id]) {
      setLoadedCollections(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, id, true));
      });
      dispatch((0,productSlice/* fetchProductCollections */.Rc)({
        slug: modelSlug,
        page: 1,
        perPage: perPage,
        collection_id: id,
        onSuccess: function onSuccess(data) {
          setCollections(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, id, data));
          });
        },
        onError: function onError() {
          setCollections(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, id, true));
          });
        }
      }));
    }
  };

  var lookBlock = (0,react.useMemo)(function () {
    if (lookId) {
      if (look === true) {
        return null;
      }

      if (look) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Collections_module_default()).looks,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LookImageSliderBlock */.yC, _objectSpread(_objectSpread({}, look), {}, {
            productPage: true
          }))
        });
      } else {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: collectionIds.length > 0 && (Collections_module_default()).skeletonLookViewport,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ViewportBlock, {
            onEnterViewport: function onEnterViewport() {
              getLook();
            }
          })
        });
      }
    }

    return null;
  }, [lookId, look, getLook]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [lookBlock, collectionIds.map(function (id) {
      var collection = collections[id];

      if (collection === true) {
        return null;
      }

      if (collection) {
        var type = collection.type,
            collectionTitle = collection.title,
            products = collection.products,
            full_row = collection.full_row,
            pagesCount = collection.pages,
            _id = collection.id;

        switch (type) {
          case 'wide':
            {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (Collections_module_default()).collectionItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(WideCollection, {
                  id: _id,
                  title: collectionTitle,
                  products: products,
                  full_row: full_row,
                  currency: currency,
                  pagesCount: pagesCount,
                  perPage: perPage,
                  slug: modelSlug,
                  SkeletonContainer: SkeletonContainer
                }, collectionTitle)
              });
            }

          case 'narrow':
            {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (Collections_module_default()).collectionItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(NarrowCollection, {
                  title: collectionTitle,
                  products: products,
                  currency: currency
                }, collectionTitle)
              });
            }

          default:
            return null;
        }
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Collections_module_default()).skeletonCollectionViewport,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ViewportBlock, {
          onEnterViewport: function onEnterViewport() {
            getCollection(id);
          }
        })
      });
    })]
  });
};

/* harmony default export */ var components_Collections = (Collections);
// EXTERNAL MODULE: ./layouts/ProductPage/ProductPage.module.scss
var ProductPage_module = __webpack_require__(20012);
var ProductPage_module_default = /*#__PURE__*/__webpack_require__.n(ProductPage_module);
;// CONCATENATED MODULE: ./layouts/ProductPage/ProductPage.js




function ProductPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










 // import useWindowSize from '@/hooks/use-window-size';















var Product = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7748).then(__webpack_require__.bind(__webpack_require__, 67748));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(67748)];
    }
  }
});
var Viewed = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7710).then(__webpack_require__.bind(__webpack_require__, 47710));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(47710)];
    }
  }
});

var isEqualIds = function isEqualIds(ids, historyIds) {
  return ids.every(function (id) {
    return historyIds[id];
  });
};

var ProductPage = function ProductPage() {
  var _data$og$title, _data$og, _data$og$description, _data$og2, _data$og$image_big, _data$og3, _data$og$image_small, _data$og4, _data$gallery, _data$gallery$, _data$gallery2, _data$gallery2$;

  var router = (0,next_router.useRouter)();
  var data = (0,es/* useSelector */.v9)(store/* productDataSelector */.Fe);
  var currency = (0,es/* useSelector */.v9)(currencySlice/* getCurrency */.zC);

  var _useState = (0,react.useState)([]),
      historyProducts = _useState[0],
      setHistoryProducts = _useState[1];

  var _useState2 = (0,react.useState)(-1),
      firstProductId = _useState2[0],
      setFirstProductId = _useState2[1];

  var _useState3 = (0,react.useState)({
    pageName: 'Страница товара',
    indexCard: 1
  }),
      productInfoGA = _useState3[0],
      setProductInfoGA = _useState3[1];

  var query = router.query;

  var _useSelector = (0,es/* useSelector */.v9)(store/* productShopsSelector */.OT),
      shopsData = _useSelector.data,
      loadingShops = _useSelector.loading;

  var _ref = data || {},
      brand = _ref.brand,
      name = _ref.name,
      price = _ref.price,
      seo = _ref.seo,
      model = _ref.model,
      _ref$breadcrumbs_seco = _ref.breadcrumbs_second,
      breadcrumbs_second = _ref$breadcrumbs_seco === void 0 ? null : _ref$breadcrumbs_seco;

  var modelId = model === null || model === void 0 ? void 0 : model.id;
  var modelSlug = model === null || model === void 0 ? void 0 : model.slug;

  var _qs$parse = lib_default().parse(query),
      _qs$parse$variant = _qs$parse.variant,
      variant = _qs$parse$variant === void 0 ? null : _qs$parse$variant;

  var title = "".concat(name, " ").concat(brand, " | \u041A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044F ").concat(brand, " \u043D\u0430 fh.by");
  var description = "".concat(name, " ").concat(brand, " \u0437\u0430 ").concat(price, " byn \u0432 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435 FH.BY. ").concat((0,config/* getEmoji */.gx)('checkMark'), " \u0422\u043E\u043B\u044C\u043A\u043E \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u0440\u0435\u043D\u0434\u044B. \u0423\u0434\u043E\u0431\u043D\u044B\u0439 \u043E\u043D\u043B\u0430\u0439\u043D-\u043A\u0430\u0442\u0430\u043B\u043E\u0433: \u0446\u0435\u043D\u044B, \u0444\u043E\u0442\u043E, \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435. ").concat((0,config/* getEmoji */.gx)('deliveryTruck'), " \u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043F\u043E \u0432\u0441\u0435\u0439 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u0438");
  var ogTitle = (_data$og$title = data === null || data === void 0 ? void 0 : (_data$og = data.og) === null || _data$og === void 0 ? void 0 : _data$og.title) !== null && _data$og$title !== void 0 ? _data$og$title : '';
  var ogDescription = (_data$og$description = data === null || data === void 0 ? void 0 : (_data$og2 = data.og) === null || _data$og2 === void 0 ? void 0 : _data$og2.description) !== null && _data$og$description !== void 0 ? _data$og$description : '';
  var ogImageRect = (_data$og$image_big = data === null || data === void 0 ? void 0 : (_data$og3 = data.og) === null || _data$og3 === void 0 ? void 0 : _data$og3.image_big) !== null && _data$og$image_big !== void 0 ? _data$og$image_big : null;
  var ogImageSquare = (_data$og$image_small = data === null || data === void 0 ? void 0 : (_data$og4 = data.og) === null || _data$og4 === void 0 ? void 0 : _data$og4.image_small) !== null && _data$og$image_small !== void 0 ? _data$og$image_small : null;

  var _useLocalStorage = (0,use_local_storage/* default */.Z)('history', {
    count: 0,
    ids: {},
    products: []
  }),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      history = _useLocalStorage2[0],
      setHistory = _useLocalStorage2[1];

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useSelector2 = (0,es/* useSelector */.v9)(viewedSlice/* getViewedData */.En),
      count = _useSelector2.count,
      ids = _useSelector2.ids,
      isFromSession = _useSelector2.isFromSession;

  (0,react.useEffect)(function () {
    if (Object.keys(currency).length && true) {
      var _productInfo$pageName, _productInfo, _productInfo$indexCar, _productInfo2;

      var productInfo = null;
      var productInfoStr = localStorage.getItem('productInfo');

      if (productInfoStr) {
        productInfo = JSON.parse(productInfoStr);
        setProductInfoGA(productInfo);
      }

      var newProducts = (0,getProductWithoutQuantity/* default */.Z)([data]);
      Ecommerce/* default.viewItemList */.ZP.viewItemList(newProducts, currency, (_productInfo$pageName = (_productInfo = productInfo) === null || _productInfo === void 0 ? void 0 : _productInfo.pageName) !== null && _productInfo$pageName !== void 0 ? _productInfo$pageName : 'Страница товара', 'view_item', (_productInfo$indexCar = (_productInfo2 = productInfo) === null || _productInfo2 === void 0 ? void 0 : _productInfo2.indexCard) !== null && _productInfo$indexCar !== void 0 ? _productInfo$indexCar : 1);
      window.localStorage.removeItem('productInfo');
    }
  }, [currency, modelId]);
  (0,react.useEffect)(function () {
    if (isFromSession && (history.count !== count || !isEqualIds(ids, history.ids))) {
      dispatch((0,viewedSlice/* fetchHistory */.eL)({
        onSuccess: function onSuccess(items) {
          var newIds = items.map(function (item) {
            return item.model.id;
          });
          var idsObj = (0,utils/* getObjectFromArray */.PX)(newIds);
          dispatch((0,viewedSlice/* updateHistoryIds */._h)({
            ids: newIds,
            count: newIds.length
          }));
          setHistory({
            count: newIds.length,
            ids: idsObj,
            products: items
          });
        }
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isFromSession, currency]);
  (0,react.useEffect)(function () {
    dispatch((0,viewedSlice/* updateViewed */.Zo)({
      model_id: modelId
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelId, dispatch]);
  (0,react.useEffect)(function () {
    if (isFromSession && history.count === count && isEqualIds(ids, history.ids)) {
      if (!history.ids[modelId]) {
        dispatch((0,viewedSlice/* updateHistoryIds */._h)({
          ids: [modelId].concat((0,toConsumableArray/* default */.Z)(ids)),
          count: count + 1
        }));
        setHistory({
          count: count + 1,
          ids: ProductPage_objectSpread((0,defineProperty/* default */.Z)({}, modelId, true), history.ids),
          products: [data].concat((0,toConsumableArray/* default */.Z)(history.products))
        });
      } else {
        var indexToFirst = -1;

        if (history.products[0].model.id !== modelId) {
          var newArray = history.products.filter(function (item, index) {
            if (item.model.id !== modelId) {
              return true;
            } else {
              indexToFirst = index;
              return false;
            }
          });

          if (indexToFirst > 0) {
            setHistory(ProductPage_objectSpread(ProductPage_objectSpread({}, history), {}, {
              products: [history.products[indexToFirst]].concat((0,toConsumableArray/* default */.Z)(newArray))
            }));
          }
        } else {
          setHistoryProducts(history.products.slice(1));
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [modelId, history, count, ids, data, isFromSession]);
  (0,react.useEffect)(function () {
    var _data$attributes;

    var uuid = data.uuid;
    var options = [];
    data === null || data === void 0 ? void 0 : (_data$attributes = data.attributes) === null || _data$attributes === void 0 ? void 0 : _data$attributes.forEach(function (item) {
      if (item.name === 'Размер производителя') {
        options = (0,toConsumableArray/* default */.Z)(item.options);
      }
    });

    if (options.length) {
      if (variant) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].variant_id == variant) {
            uuid = options[i].uuid;
            break;
          }
        }
      } else {
        uuid = options[0].uuid;

        for (var _i = 0; _i < options.length; _i++) {
          if (options[_i].has) {
            uuid = options[_i].uuid;
            break;
          }
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps


    Mindbox/* default */.ZP === null || Mindbox/* default */.ZP === void 0 ? void 0 : Mindbox/* default.displayProductDetail */.ZP.displayProductDetail({
      product: {
        uuid: uuid
      }
    });
  }, [modelId]);
  var handleClickOpenShops = (0,react.useCallback)(function () {
    dispatch((0,productSlice/* fetchProductShops */.MZ)({
      slug: modelSlug
    }));
  }, [dispatch, modelSlug]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* MetaData */.U4, {
      title: title,
      description: description,
      seo: seo,
      ogTitle: ogTitle,
      ogDescription: ogDescription,
      image: ogImageRect || (data === null || data === void 0 ? void 0 : (_data$gallery = data.gallery) === null || _data$gallery === void 0 ? void 0 : (_data$gallery$ = _data$gallery[0]) === null || _data$gallery$ === void 0 ? void 0 : _data$gallery$.x2),
      imageSmall: ogImageSquare || (data === null || data === void 0 ? void 0 : (_data$gallery2 = data.gallery) === null || _data$gallery2 === void 0 ? void 0 : (_data$gallery2$ = _data$gallery2[0]) === null || _data$gallery2$ === void 0 ? void 0 : _data$gallery2$.x2),
      type: "product",
      productData: data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(JsonLd/* JsonLdData */.j, {
      product: data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        className: (ProductPage_module_default()).section,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Product, {
          data: ProductPage_objectSpread(ProductPage_objectSpread({}, data), {}, {
            clickOpenShops: handleClickOpenShops,
            shops: shopsData === null || shopsData === void 0 ? void 0 : shopsData.shops,
            loadingShops: loadingShops
          }),
          productInfo: productInfoGA
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Collections, {
        collectionIds: data.collection_ids,
        lookId: data.look_id,
        modelSlug: modelSlug,
        currency: currency
      }, modelId)
    }), historyProducts && historyProducts.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Viewed, {
        products: historyProducts,
        currency: currency,
        setFirstProductId: setFirstProductId,
        firstProductId: firstProductId
      }, modelId)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductPage_module_default()).breadCrumbs,
        children: breadcrumbs_second && breadcrumbs_second.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
          breadcrumbs: breadcrumbs_second
        })
      })
    })]
  });
};

/* harmony default export */ var ProductPage_ProductPage = (ProductPage);
;// CONCATENATED MODULE: ./layouts/ProductPage/index.js

/* harmony default export */ var layouts_ProductPage = (ProductPage_ProductPage);

/***/ }),

/***/ 20012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"ProductPage_skeletonContainer__VXKNa","skeleton":"ProductPage_skeleton__xwubM","skeletonSizeOne":"ProductPage_skeletonSizeOne__f72aE","skeletonSizeTwo":"ProductPage_skeletonSizeTwo__DkaB4","nonVisibleStyle":"ProductPage_nonVisibleStyle__kesXW","collectionTitle":"ProductPage_collectionTitle__2m_SJ","section":"ProductPage_section__gXxut","breadCrumbs":"ProductPage_breadCrumbs__W3LKY","load":"ProductPage_load__kP_Af"};

/***/ }),

/***/ 55574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"Collections_skeletonContainer__JmHoF","skeleton":"Collections_skeleton__9_afY","skeletonSizeOne":"Collections_skeletonSizeOne__QAUMp","skeletonSizeTwo":"Collections_skeletonSizeTwo__TuzA_","looks":"Collections_looks__8KmdA","skeletonLookViewport":"Collections_skeletonLookViewport__twUfQ","skeletonCollectionViewport":"Collections_skeletonCollectionViewport__YYnIS","collectionItem":"Collections_collectionItem__hOfBr","skeletonTitle":"Collections_skeletonTitle__tgI6F","load":"Collections_load__JP4Xi"};

/***/ }),

/***/ 19231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.NM = __webpack_unused_export__ = exports.ZP = __webpack_unused_export__ = void 0;

var _handleViewport = _interopRequireDefault(__webpack_require__(77095));

__webpack_unused_export__ = _handleViewport.default;

var _useInViewport = _interopRequireDefault(__webpack_require__(32659));

exports.NM = _useInViewport.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customProps = ['inViewport', 'enterCount', 'leaveCount'];
__webpack_unused_export__ = customProps;
var _default = _handleViewport.default;
exports.ZP = _default;

/***/ }),

/***/ 61319:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports.noop = exports.defaultProps = exports.defaultOptions = exports.defaultConfig = void 0;
var defaultOptions = {};
exports.defaultOptions = defaultOptions;
var defaultConfig = {
  disconnectOnLeave: false
};
exports.defaultConfig = defaultConfig;

var noop = () => {};

exports.noop = noop;
var defaultProps = {
  onEnterViewport: noop,
  onLeaveViewport: noop
};
exports.defaultProps = defaultProps;

/***/ }),

/***/ 77095:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__(67294);

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(8679));

var _useInViewport = _interopRequireDefault(__webpack_require__(32659));

var _constants = __webpack_require__(61319);

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["onEnterViewport", "onLeaveViewport"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var isFunctionalComponent = Component => {
  return typeof Component === 'function' && !(Component.prototype && Component.prototype.render);
};

var isReactComponent = Component => {
  return Component.prototype && Component.prototype.isReactComponent;
};

function handleViewport(TargetComponent, options, config) {
  if (options === void 0) {
    options = _constants.defaultOptions;
  }

  if (config === void 0) {
    config = _constants.defaultConfig;
  }

  var ForwardedRefComponent = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
    var refProps = _extends({
      forwardedRef: ref
    }, isReactComponent(TargetComponent) && !isFunctionalComponent(TargetComponent) ? {
      ref
    } : {});

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(TargetComponent, _extends({}, props, refProps));
  });

  function InViewport(_ref) {
    var {
      onEnterViewport = _constants.noop,
      onLeaveViewport = _constants.noop
    } = _ref,
        restProps = _objectWithoutPropertiesLoose(_ref, _excluded);

    var node = (0, _react.useRef)();
    var {
      inViewport,
      enterCount,
      leaveCount
    } = (0, _useInViewport.default)(node, options, config, {
      onEnterViewport,
      onLeaveViewport
    });
    var injectedProps = {
      inViewport,
      enterCount,
      leaveCount
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ForwardedRefComponent, _extends({}, restProps, injectedProps, {
      ref: node
    }));
  }

  var name = TargetComponent.displayName || TargetComponent.name || 'Component';
  InViewport.displayName = "handleViewport(" + name + ")";
  return (0, _hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}

var _default = handleViewport;
exports["default"] = _default;

/***/ }),

/***/ 32659:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__(67294);

var _reactDom = __webpack_require__(73935);

var _constants = __webpack_require__(61319);

var useInViewport = function useInViewport(target, options, config, props) {
  if (options === void 0) {
    options = _constants.defaultOptions;
  }

  if (config === void 0) {
    config = _constants.defaultConfig;
  }

  if (props === void 0) {
    props = _constants.defaultProps;
  }

  var {
    onEnterViewport,
    onLeaveViewport
  } = props;
  var [, forceUpdate] = (0, _react.useState)();
  var observer = (0, _react.useRef)();
  var inViewportRef = (0, _react.useRef)(false);
  var intersected = (0, _react.useRef)(false);
  var enterCountRef = (0, _react.useRef)(0);
  var leaveCountRef = (0, _react.useRef)(0);

  function startObserver(_ref) {
    var {
      observerRef
    } = _ref;
    var targetRef = target.current;

    if (targetRef) {
      var node = (0, _reactDom.findDOMNode)(targetRef);

      if (node) {
        observerRef == null ? void 0 : observerRef.observe(node);
      }
    }
  }

  function stopObserver(_ref2) {
    var {
      observerRef
    } = _ref2;
    var targetRef = target.current;

    if (targetRef) {
      var node = (0, _reactDom.findDOMNode)(targetRef);

      if (node) {
        observerRef == null ? void 0 : observerRef.unobserve(node);
      }
    }

    observerRef == null ? void 0 : observerRef.disconnect();
    observer.current = null;
  }

  function handleIntersection(entries) {
    var entry = entries[0] || {};
    var {
      isIntersecting,
      intersectionRatio
    } = entry;
    var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0; // enter

    if (!intersected.current && isInViewport) {
      intersected.current = true;
      onEnterViewport == null ? void 0 : onEnterViewport();
      enterCountRef.current += 1;
      inViewportRef.current = isInViewport;
      forceUpdate(isInViewport);
      return;
    } // leave


    if (intersected.current && !isInViewport) {
      intersected.current = false;
      onLeaveViewport == null ? void 0 : onLeaveViewport();

      if (config.disconnectOnLeave && observer.current) {
        // disconnect obsever on leave
        observer.current.disconnect();
      }

      leaveCountRef.current += 1;
      inViewportRef.current = isInViewport;
      forceUpdate(isInViewport);
    }
  }

  function initIntersectionObserver(_ref3) {
    var {
      observerRef
    } = _ref3;

    if (!observerRef) {
      observer.current = new IntersectionObserver(handleIntersection, options);
      return observer.current;
    }

    return observerRef;
  }

  (0, _react.useEffect)(() => {
    var observerRef = observer.current; // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

    observerRef = initIntersectionObserver({
      observerRef
    });
    startObserver({
      observerRef
    });
    return () => {
      stopObserver({
        observerRef
      });
    };
  }, [target.current, options, config, onEnterViewport, onLeaveViewport]);
  return {
    inViewport: inViewportRef.current,
    enterCount: enterCountRef.current,
    leaveCount: leaveCountRef.current
  };
};

var _default = useInViewport;
exports["default"] = _default;

/***/ })

}]);